/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_Col_DirectoryInputs */

const en_directory_external_directories_col_directory = /** @type {(inputs: Directory_External_Directories_Col_DirectoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Directory`)
};

const zh_directory_external_directories_col_directory = /** @type {(inputs: Directory_External_Directories_Col_DirectoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录`)
};

/**
* | output |
* | --- |
* | "Directory" |
*
* @param {Directory_External_Directories_Col_DirectoryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_col_directory = /** @type {((inputs?: Directory_External_Directories_Col_DirectoryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_Col_DirectoryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_col_directory(inputs)
	return zh_directory_external_directories_col_directory(inputs)
});
export { directory_external_directories_col_directory as "directory.external_directories.col_directory" }